<template>
  <div class="w-full h-full only-image" :class="{ 'cursor-default': readonly && !file }" @click="onClickImage" @dragenter="onDrag" @dragover="onDrag" @drop="onDrop" :style="{ backgroundImage: `url(${!!file ? file.path : ''})` }">
    <div v-if="!!file">
      <div class="delete-button-container" @click.stop="deleteImage" v-if="!readonly">
        <img src="@/assets/images/icon/icon-close.svg" alt="close" />
      </div>
    </div>
    <div v-else-if="!readonly" class="upload-info-container">
      <div class="upload-icon mb-2"></div>
      <span class="upload-info-title">이미지 업로드</span>
      <span class="upload-info-subtitle">이미지를 드롭하거나 여기를 클릭하여 업로드하세요.</span>
      <input :id="id" :ref="`${id}_fileInput`" type="file" @change="handleChangeFile" style="display: none" accept="image/png, image/jpeg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FileUploaderTransparent2",
  props: {
    value: Object | undefined,
    readonly: Boolean,
  },
  data() {
    return {
      id: "file_upload",
      file: this.value,
      // 클립보드에 이미지를 저장한 상태로,
      // 클릭시 뜨는 팝업 중 탐색기 열기 버튼을 클릭했을 때 팝업이 바로 뜨는 것을 막기 위해 추가된 변수
      checkingClipboard: false,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.file = value;
      },
    },
    file: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    this.id = `file_input_${Math.floor(Math.random() * 10000)}`;
  },
  methods: {
    async file_upload(files) {
      if (files.length > 0) {
        this.$emit('progress', 'start')
        await this.$store.dispatch("file/FILE_UPLOAD", files[0]).then((data) => {
          this.$emit('progress', 'success', data)
        }).catch((err) => {
          this.$emit('progress', 'fail', err)
        });
        const data = this.$store.state.file.uploadedFile;
        this.file = data;
      }
    },

    deleteImage(evt) {
      this.file = null;
      evt.preventDefault();
    },

    async onClickImage() {
      if (this.checkingClipboard) return;
      this.checkingClipboard = true;

      // Check if device is mobile
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      let clipboardImageFile = false;
      if (!isMobile) {
        clipboardImageFile = await this.checkClipboardForImage();
      }

      if (!!this.file) {
        window.open(this.file.path, "_blank");
        this.checkingClipboard = false;
      } else if (!clipboardImageFile) {
        this.$refs[`${this.id}_fileInput`].click();
        this.checkingClipboard = false;
      } else {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "이미지 업로드",
            messageIcon: "AlertCircleIcon",
            message: "클립보드의 이미지를 사용하시겠습니까?",
            useConfirm: true,
            confirmBtn: "클립보드 사용",
            cancelBtn: "파일탐색기 열기",
            confirmFunction: () => {
              this.changeFile([clipboardImageFile]);
              this.checkingClipboard = false;
            },
            cancelFunction: () => {
              this.$refs[`${this.id}_fileInput`].click();
              this.checkingClipboard = false;
            },
            closeFunction: () => {
              this.checkingClipboard = false;
            },
            size: "small",
            btnPosition: "center",
            confirmBtnStyle: {
              type: "border",
              icon: { type: "image", name: "icon-print-layout-vertical.svg" },
              style: "",
            },
            cancelBtnStyle: {
              type: "border",
              icon: { type: "image", name: "icon-folder.svg" },
              style: "",
            },
          },
        });
        window.dispatchEvent(customAlert);
      }
    },

    onDrop(evt) {
      if (!this.readonly) {
        if (evt && evt.dataTransfer && evt.dataTransfer.files) {
          this.changeFile(evt.dataTransfer.files);
        }
      }

      evt.preventDefault();
    },

    onDrag(evt) {
      evt.preventDefault();
    },

    handleChangeFile(event) {
      this.changeFile(event.target.files);
    },

    changeFile(files) {
      this.file_upload(files);
    },

    async checkClipboardForImage() {
      try {
        const clipboardItems = await navigator.clipboard.read();
        for (const item of clipboardItems) {
          const index = item.types.findIndex((type) => type === 'image/png' || type === 'image/jpeg');
          if (item.types.includes('image/png') || item.types.includes('image/jpeg')) {
            const blob = await item.getType(item.types[index]);
            return new File([blob], 'clipboard-image.png', { type: blob.type });
          }
        }
        console.log('클립보드에 이미지가 없습니다.');
        return false;
      } catch (error) {
        console.error('클립보드 접근 중 오류가 발생했습니다:', error);
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-info-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(8px);

  .upload-icon {
    width: 36px;
    height: 32px;
    background-image: url("~@/assets/images/icon/icon-file-upload.svg");
    background-size: contain;
  }

  .upload-info-title {
    font-size: 0.9em;
    font-weight: bold;
  }

  .upload-info-subtitle {
    font-size: 0.8em;
    font-weight: normal;
  }
}

.only-image {
  cursor: pointer;

  &.cursor-default {
    cursor: default;
  }
  position: relative;

  background-color: rgba(255, 255, 255, 0.6);
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  color: #3c3c3c;
  font-size: 18px;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  .delete-button-container {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 999px;
    border: 1px solid #222;

    > img {
      position: relative;
      width: 12px;
      height: 12px;
    }
  }
}
</style>
